import React from 'react'
import styled from 'styled-components'

import { useScrollDirection } from '../../helpers/useScrollDirection'
import theme from './theme'

interface StickyHeaderStyles {
  children: JSX.Element | JSX.Element[]
}

const StickyStyle = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  transform: ${(props): string => (props.isScrollingUp ? 'translate3D(0, 0, 0)' : 'translate3D(0, -100%, 0)')};
  width: 100%;
  z-index: 100;
  transition: transform ${theme.animation.defaultLength} ease-in-out;
`

const StickyHeader = (props: StickyHeaderStyles): JSX.Element => {
  const scrollDirection = useScrollDirection()
  const isScrollingUp = scrollDirection === 'up'

  return (
    <StickyStyle isScrollingUp={isScrollingUp}>{props.children}</StickyStyle>
  )
}

export default StickyHeader
